import AppLayout from "../components/global/layout/Layout"
import { useSelector } from 'react-redux';
import { Navigate, useParams } from 'react-router-dom';
import useCan from "../hooks/useCan";

const ProtectedRoute = ({ type, path, children, title, parent, module, subModule, action = "view" }) => {
    const { loggedIn } = useSelector(state => state.user);
    const params = useParams();
    const can = useCan();

    let mainParent = parent;
    if (parent) {
        mainParent = parent.map(item => ({ ...item, path: item.path.replace(':id', params.id) }));
    }

    if (type === "private") {
        if (!loggedIn) return <Navigate to="/" replace />;
        if (!can(module, action, subModule)) return <Navigate to="/dashboard" replace />;
        return <AppLayout title={title} parent={mainParent}>{children}</AppLayout>;
    }

    if (type === "public") {
        return children;
    }

    if (type === "auth") {
        if (!loggedIn) return children;
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default ProtectedRoute;
